import _ from 'underscore';
import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';
import { restrictionRequestStore } from '../stores/restrictionRequest';
import { schematicToolbarStore } from '../stores/schematicToolbar';
import { formValidation } from '../util/formValidation';
import { schematicUtil } from '../util/schematicUtil';
const { ActionTypes, RenderTypes } = Constants;

//require the schematic components
var Schematic = require("tmds/Schematic");
var SvgElement = require("tmds/SvgElement");
var Point = require("tmds/geometry/Point");
var Layer = require("tmds/layers/Layer");
var CompositePointSymbol = require("tmds/symbols/CompositePointSymbol");
var SimplePointSymbol = require("tmds/symbols/SimplePointSymbol");
var TextSymbol = require("tmds/symbols/TextSymbol");
var SvgUtil = require('tmds/utils/svgUtils');

var Color = Constants.Colors;
//local variables
var selectionLayer,//layer to hold the guids being actively selected
    deselectionLayer,//layer to hold the guids being actively deselected
    currentRestrictionLayer,//layer to hold the guids that are part of the active restriction being submitted
    existingRestrictionLayer,//layer to hold guids for other active restrictions on the sub
    printSchematic,
    milePostLayer,
    hoverLayer,
    alphaTextLayer,//TMDS layer
    trackLayer,//TMDS layer
    signalLayer,//TMDS layer
    RrCrossingLayer,//TMDS layer
    switchLayer,//TMDS layer
    controlPointLayer,//TMDS layer
    restriction,//the restriction from the formBstore
    trackLayerIds,//constant to hold all the track layers
    trackFields,//constant to hold all the track fields
    subdivision,
    subdivisionDetails,
    excludedGuids = [],
    validRenderTypes = [RenderTypes.normal, RenderTypes.other],//all the valid selectable track renderTypes
    excludableTracks = ['TURNOUT', 'CROSSOVER'],//all the track names that are excludable,case shouldn't matter when the comparison is made
    linkNames = ['leftLink', 'rightLink', 'altLinkOne', 'altLinkTwo', 'leftAltLink', 'rightAltLink'],
    hover = $('#guidHoverDiv'),
    guidSub = $('#guidSub'),
    guidId = $('#guidId'),
    guidMps = $('#guidMps'),
    guidTrack = $('#guidTrack'),
    currentMp = $('#currentMp'),
    contextMenu = $('#contextMenuDiv'),
    contextMenuMp = $('#mpValue'),
    contextMenuSfx = $('#sfxValue'),
    contextMenuFromMpDiv = document.getElementById('fromMpDiv'),
    contextMenuToMpDiv = document.getElementById('toMpDiv'),
    contextMenuCancelDiv = document.getElementById('ctxCancelDiv'),
    currentRangedText,
    trackLayerGraph,
    defaultTracks,
    mpRangeGraphs = {
        OTTUMW: {
            "defaultDirection": "W",
            "defaultTimezone": "C",
            "fullName": "OTTUMWA",
            "name": "OTTUMW",
            "usesGTB": true,
            "milePostRangeList": [
                {
                    "from": 392.9,
                    "to": 307.999,
                    "sfx": null,
                    "fnode": 0,
                    "tnode": 1
                },
                {
                    "from": 309,
                    "to": 308,
                    "sfx": "A",
                    "fnode": 1,
                    "tnode": 2
                },
                {
                    "from": 307.999,
                    "to": 307.998,
                    "sfx": null,
                    "fnode": 1,
                    "tnode": 2
                },
                {
                    "from": 307.998,
                    "to": 170,
                    "sfx": null,
                    "fnode": 2,
                    "tnode": 4
                },
                {
                    "from": 1.1,
                    "to": 0,
                    "sfx": null,
                    "fnode": 3,
                    "tnode": 4
                },
                {
                    "from": 170,
                    "to": 162.4,
                    "sfx": null,
                    "fnode": 4,
                    "tnode": 5
                }
            ]
        },
        SELIGM: {
            "defaultDirection": "W",
            "defaultTimezone": "M",
            "fullName": "SELIGMAN",
            "milePostRangeList": [
                {
                    "from": 578.4,
                    "to": 526.7,
                    "sfx": null,
                    "fnode": 0,
                    "tnode": 1,
                },
                {
                    "from": 526.7,
                    "to": 514.1,
                    "sfx": null,
                    "fnode": 1,
                    "tnode": 2,
                },
                {
                    "from": 526.7,
                    "to": 514.1,
                    "sfx": "X",
                    "fnode": 1,
                    "tnode": 2,
                },
                {
                    "from": 514.1,
                    "to": 461,
                    "sfx": null,
                    "fnode": 2,
                    "tnode": 3,
                },
                {
                    "from": 461,
                    "to": 457,
                    "sfx": "X",
                    "fnode": 3,
                    "tnode": 4,
                },
                {
                    "from": 461,
                    "to": 457,
                    "sfx": null,
                    "fnode": 3,
                    "tnode": 4,
                },
                {
                    "from": 457,
                    "to": 436,
                    "sfx": null,
                    "fnode": 4,
                    "tnode": 5,
                },
                {
                    "from": 436,
                    "to": 432,
                    "sfx": "X",
                    "fnode": 5,
                    "tnode": 6,
                },
                {
                    "from": 436,
                    "to": 432,
                    "sfx": null,
                    "fnode": 5,
                    "tnode": 6,
                },
                {
                    "from": 432,
                    "to": 419,
                    "sfx": null,
                    "fnode": 6,
                    "tnode": 7,
                },
                {
                    "from": 419,
                    "to": 418,
                    "sfx": "A",
                    "fnode": 7,
                    "tnode": 8,
                },
                {
                    "from": 418.9,
                    "to": 284.5,
                    "sfx": null,
                    "fnode": 8,
                    "tnode": 9,
                },
            ],
            "name": "SELIGM",
            "usesGTB": true
        },
        REDROC: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "RED ROCK",
            "milePostRangeList": [
                {
                    "from": 411.3,
                    "to": 417.8,
                    "sfx": "X",
                    "fnode": 0,
                    "tnode": 1
                },
                {
                    "from": 418,
                    "to": 517.1,
                    "sfx": null,
                    "fnode": 1,
                    "tnode": 2
                },
                {
                    "from": 417.8,
                    "to": 263.4,
                    "sfx": null,
                    "fnode": 2,
                    "tnode": 3
                },

            ],
            "name": "REDROC",
            "usesGTB": true
        },
        FTWORT: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "FORT WORTH",
            "milePostRangeList": [
                {
                    "from": 218.1,
                    "to": 342.231,
                    "sfx": null,
                    "fnode": 0,
                    "tnode": 1
                },
                {
                    "from": 0.971,
                    "to": 0.0,
                    "sfx": null,
                    "fnode": 2,
                    "tnode": 1
                },
                {
                    "from": 342.231,
                    "to": 345.362,
                    "sfx": null,
                    "fnode": 1,
                    "tnode": 3
                },
                {   //This is a virtual node I am adding for testing
                    "from": 345.362,
                    "to": 345.755,
                    "sfx": null,
                    "fnode": 3,
                    "tnode": 4
                },
                {
                    "from": 345.755,
                    "to": 385.477,
                    "sfx": null,
                    "fnode": 4,
                    "tnode": 5
                },
                {
                    "from": 385.477,
                    "to": 386.0,
                    "sfx": null,
                    "fnode": 5,
                    "tnode": 6
                },
                {
                    "from": 385.477,
                    "to": 386.0,
                    "sfx": "X",
                    "fnode": 5,
                    "tnode": 6
                },
                {
                    "from": 386.0,
                    "to": 411.3,
                    "sfx": null,
                    "fnode": 6,
                    "tnode": 7
                },
                {
                    "from": 632.143,
                    "to": 632.378,
                    "sfx": null,
                    "fnode": 8,
                    "tnode": 9
                },

            ],
            "name": "FTWORT",
            "usesGTB": true
        },
        STJOSE: {
            "defaultDirection": "W",
            "defaultTimezone": "C",
            "fullName": "ST JOSEPH",
            "milePostRangeList": [
                {
                    "from": 207.6,
                    "to": 64.0,
                    "sfx": null,
                    "fnode": 0,
                    "tnode": 1
                },
                {
                    "from": 62.52,
                    "to": 1.0,
                    "sfx": null,
                    "fnode": 1,
                    "tnode": 2
                },
                {
                    "from": 1.843,
                    "to": 0.5,
                    "sfx": null,
                    "fnode": 2,
                    "tnode": 4
                },
                {
                    "from": 1.0,
                    "to": 0.2,
                    "sfx": "Z",
                    "fnode": 2,
                    "tnode": 3
                },

            ],
            "name": "STJOSE",
            "usesGTB": true
        },
        MYKAWA: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "MYKAWA",
            "milePostRangeList": [
                {
                    "from": 0.0,
                    "to": 19.627,
                    "sfx": null,
                    "fnode": 0,
                    "tnode": 1
                }

            ],
            "name": "MYKAWA",
            "usesGTB": true
        },
        GALVES: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "GALVESTON",
            "milePostRangeList": [
                {
                    "from": 0.3,
                    "to": 24.327,
                    "sfx": null,
                    "fnode": 0,
                    "tnode": 1
                },
                {
                    "from": 341.2,
                    "to": 343.3,
                    "sfx": null,
                    "fnode": 1,
                    "tnode": 2
                },
                {
                    "from": 24.327,
                    "to": 218.1,
                    "sfx": null,
                    "fnode": 2,
                    "tnode": 3
                },
                {
                    "from": 880.682,
                    "to": 880.912,
                    "sfx": null,
                    "fnode": 4,
                    "tnode": 5
                }
            ],
            "name": "GALVES",
            "usesGTB": true
        }
    },
    haveGraph = false;

export const PrintSchematicActions = {

    initialize: function () {

        printSchematic = new Schematic("printSchematic", {
            env: window.gritConfig.gisEnvironment,
            useTrackAltName: true,
            renderMode: "GRIT"
        });

        //get the schematic constants for use
        trackLayerIds = Schematic.tmdsLayerIds();
        trackFields = Schematic.trackKeyFields();

        //get a reference to the track layer for later
        trackLayer = printSchematic.getLayer(trackLayerIds.TMDS_TRACK);
        signalLayer = printSchematic.getLayer(trackLayerIds.TMDS_SIGNAL);
        RrCrossingLayer = printSchematic.getLayer(trackLayerIds.TMDS_INTERLOCKER);
        switchLayer = printSchematic.getLayer(trackLayerIds.TMDS_SWITCH);
        controlPointLayer = printSchematic.getLayer(trackLayerIds.TMDS_CONTROLPOINT);
        alphaTextLayer = printSchematic.getLayer(trackLayerIds.TMDS_ALPHATEXT);

        /**
         * Test draw toolbar
         */
        //drawTool = new Draw(schematic);
        //drawTool.on("draw-end", onDrawEnd.bind(this));

        //drawingSelectLayer = new Layer([], {
        //    geometryType: "Extent"
        //}, {id: "drawingSelectLayer"});
        //
        //schematic.addLayer(drawingSelectLayer);
        //
        //drawingDeselectLayer = new Layer([], {
        //    geometryType: "Extent"
        //}, {id: "drawingDeselectLayer"});
        //
        //schematic.addLayer(drawingDeselectLayer);

        //schematic.addLayer(drawingSelectLayer);
        //
        //drawingDeselectLayer = new Layer([], {
        //    geometryType: "Extent"
        //}, {id: "drawingDeselectLayer"});
        //
        //schematic.addLayer(drawingDeselectLayer);

        //layers for holding guids
        existingRestrictionLayer = new Layer([], { geometryType: "Line" }, { id: "existingRestrictionLayer" });
        printSchematic.addLayer(existingRestrictionLayer);

        currentRestrictionLayer = new Layer([], { geometryType: "Line" }, { id: "currentRestrictionLayer" });
        printSchematic.addLayer(currentRestrictionLayer);

        selectionLayer = new Layer([], { geometryType: "Line" }, { id: "selectionLayer" });
        printSchematic.addLayer(selectionLayer);

        deselectionLayer = new Layer([], { geometryType: "Line" }, { id: "deselectionLayer" });
        printSchematic.addLayer(deselectionLayer);

        hoverLayer = new Layer([], { geometryType: "Line" }, { id: "hoverLayer" });
        printSchematic.addLayer(hoverLayer);

        milePostLayer = new Layer([], {
            geometryType: "Point",
            geometryInfo: {
                x: "x",
                y: "y"
            }
        }, {
            id: "lyrPoint"
        });

        printSchematic.addLayer(milePostLayer);

        registerHandlers();

    },

    cleanup: function () {
        $('#printSchematic').hide();

    },

    /**
     * Hides all the layers
     */
    hideAllLayers: function () {

        //my layers to hide
        milePostLayer.hide();
        selectionLayer.hide();
        deselectionLayer.hide();
        currentRestrictionLayer.hide();
        existingRestrictionLayer.hide();

        //TMDS layers to hide
        trackLayer.hide();
        signalLayer.hide();
        RrCrossingLayer.hide();
        switchLayer.hide();
        controlPointLayer.hide();
        alphaTextLayer.hide();
        dispatcher.dispatch({
            type: ActionTypes.HIDE_SCHEMATIC
        })
    },

    /**
     * Shows all the layers
     */
    showAllLayers: function () {

        //custom layers
        milePostLayer.show();
        selectionLayer.show();
        deselectionLayer.show();
        currentRestrictionLayer.show();
        existingRestrictionLayer.show();

        //TMDS layers
        trackLayer.show();
        signalLayer.show();
        RrCrossingLayer.show();
        switchLayer.show();
        controlPointLayer.show();
        alphaTextLayer.show();
        dispatcher.dispatch({
            type: ActionTypes.SHOW_SCHEMATIC
        })
    },

    /**
     * Sets the subdivision of the schematic
     * @param subdivision
     */
    setSubdivision: function (sub) {
        return new Promise(function (resolve, reject) {
            selectionLayer.clear();
            deselectionLayer.clear();
            milePostLayer.clear();
            currentRestrictionLayer.clear();
            existingRestrictionLayer.clear();

            var promise = printSchematic.setSubdivision(sub);

            promise.done(function () {

                defaultTracks = null;
                resolve('Subdivision Set to ' + sub);
            }).fail(function (response) {

                if (response.status == 'warn') {
                    reject('Load Warning');
                }
                else {
                    reject('Load Error');
                }

                console.log('Failed to loaded subdivision into schematic', response.message);
            });

            subdivision = sub;
        });
    },

    /**
     * Method called to pass in the subdivision details after they have been loaded from the server
     */
    subdivisionDetailsLoaded: function (details) {

        if (mpRangeGraphs[details.name]) {
            haveGraph = true;
            //we have a graph for it
            subdivisionDetails = mpRangeGraphs[details.name];
        }
        else {
            haveGraph = false;
            subdivisionDetails = details;
        }

        console.log('subdivision details saved for schematic', JSON.stringify(subdivisionDetails));
    },

    toggleSchematicCollapse: function (tabsCollapsed) {
        console.log('schematic collapsing, tabsCollapsed: ', tabsCollapsed)
        if (tabsCollapsed) {
            //modify the schematic DIV to be full because the tabs are collapsed (oppposite of the tab)
            $('#printSchematic').removeClass();
            $('#printSchematic').addClass('schematicFull');
            printSchematic.resize();

        }
        else {
            //modify the schematic DIV to be collapsed because the tabs are open (oppposite of the tab)
            $('#printSchematic').removeClass();
            $('#printSchematic').addClass('schematicCollapsed');
            printSchematic.resize();
        }
    },

    /**
     * Gets the restriction guids, waits for the schematic to be loaded, then paints the guids
     */
    openRestriction: function () {
        console.log('opening saved restriction');

        determineSchematicAction(ActionTypes.OPEN_ITEM);
    },

    openRequestForApproval: function () {
        console.log('opening saved request for approval');

        determineSchematicAction(ActionTypes.HIGHLIGHT_FROM_GUIDS);
    },

    /**
     * Clears all custom layers and hides all other layers
     */
    clearSubdivision: function () {
        selectionLayer.clear();
        deselectionLayer.clear();
        currentRestrictionLayer.clear();
        existingRestrictionLayer.clear();
        this.hideAllLayers();
    },

    /**
     * Sets the schematic to navigate mode
     */
    setNavigate: setNavigate,

    /**
     * Sets the schematic to exclusion mode
     */
    setExclude: setExclude,

    /**
     * resets the schematic without prompting
     */
    resetSchematicNoPrompt: resetSchematicNoPrompt,

    /**
     * Centers and zooms the schematic on the selected guids and MPs
     */
    centerAndZoom: centerAndZoom,

    //expose this method publicly
    updateSchematicFromText: function () {
        determineSchematicAction(ActionTypes.FORM_UPDATED, null);
    },

    updateSchematicFromRequest: function (reg) {
        determineSchematicAction(ActionTypes.FORM_UPDATED, reg);
    },

    useAlternateTrackName(should) {
        console.log("should use alternate track names: ", should);
        printSchematic.setUseTrackAltName(should);
    },

    highlightRestrictionList: function (restrictions) {
        return highlightRestrictionsForPrint(restrictions);
    },

    generatePrintElements() {
        var printElements = [];

        var layers = printSchematic._tmdsLayers;
        var trackPrintLayer = layers["tracks"];
        var switchPrintLayer = layers["switches"];
        var signalPrintLayer = layers["signals"];
        var interlockersPrintLayer = layers["interlockers"];
        var alphaTextsPrintLayer = layers["alphatexts"];
        var controlPointPrintLayer = layers["controlpoints"];


        // console.log("Track", trackPrintLayer.elements);
        printElements.push.apply(printElements, trackPrintLayer.elements);
        // console.log("Switch", switchPrintLayer.elements);
        printElements.push.apply(printElements, switchPrintLayer.elements);
        // console.log("Signal", signalPrintLayer.elements);
        printElements.push.apply(printElements, signalPrintLayer.elements);
        // console.log("Alpha Text", alphaTextsPrintLayer.elements);
        printElements.push.apply(printElements, alphaTextsPrintLayer.elements);
        // console.log("Control Point", controlPointPrintLayer.elements);
        printElements.push.apply(printElements, controlPointPrintLayer.elements);
        // console.log("Interlockers", interlockersPrintLayer.elements);
        printElements.push.apply(printElements, interlockersPrintLayer.elements);

        return printElements;
    },

    generatePrintRestrictionGuids() {
        var printGuids = [];

        var dataLayers = printSchematic._dataLayers;
        var currentRestrictionLayer = dataLayers[1];
        console.log("Current Restriction Layer");
        printGuids.push.apply(printGuids, currentRestrictionLayer.elements);
    }

};//end of public api

/**
 * Helper methods *************************************************************************************************
 */
/**
 * resets the schematic without prompting
 */
function resetSchematicNoPrompt() {
    selectionLayer.clear();
    deselectionLayer.clear();
    existingRestrictionLayer.clear();
    currentRestrictionLayer.clear();
    excludedGuids = [];
    milePostLayer.clear();

}

/**
 * resets the schematic without prompting
 */
function prepSchematicForReHighlight() {
    selectionLayer.clear();
    deselectionLayer.clear();
    existingRestrictionLayer.clear();
    currentRestrictionLayer.clear();
    milePostLayer.clear();
}


/**
 * Clears the currentRestrictionLayer then moves the guids on the selectionLayer to the currentRestrictionLayer
 */
function highlightSelectedGuids(clearLayerFirst) {

    //var guidsToAdd = getNewGuidsIfHighlightApplied();
    var guidsToAdd = selectionLayer.elements;
    if (clearLayerFirst) {
        currentRestrictionLayer.clear();
    }

    _.each(guidsToAdd, function (elem) {

        elem.symbol.setColor(Color.green);
        elem.symbol.width = 8;
        currentRestrictionLayer.addElement(elem)
    });

    selectionLayer.clear();
}


/**
 * Clears the currentRestrictionLayer then moves the guids on the selectionLayer to the currentRestrictionLayer
 */
function setSelectedGuids(guids) {

    selectionLayer.clear();

    _.each(guids, function (elem) {

        elem.symbol.setColor(Color.blue);
        elem.symbol.width = 8;
        selectionLayer.addElement(elem)
    });
}

/**
 * Centers and zooms the schematic on the selected guids and MPs
 */
function centerAndZoom() {
    if (currentRestrictionLayer.elements.length + milePostLayer.elements.length > 0) {
        centerAndZoomSchematic(_.union(currentRestrictionLayer.elements, milePostLayer.elements))
    }
    else {
        centerAndZoomSchematic(trackLayer.elements)
    }
}

/**
 * Center and zooms the schematic to fit the given elems
 * @param elems
 */
function centerAndZoomSchematic(elems) {
    var extent = SvgUtil.svgElementsExtent(elems);

    /**
     * The extent is a rectangle defined by two points (xmin, ymin) and (xmax, ymax), which surrounds
     * the given elems. By scaling the box we can control where the zoom happens. increasing the max
     * values and decreasing the min values makes the extent bigger, there by zooming out on the selection.
     *
     */
    //    //modify the extent to center the selection and give it some buffer
    if (extent) {

        extent.xmax *= 1.1;
        extent.ymax *= 1.1;

        extent.xmin /= 1.1;
        extent.ymin /= 1.1;

        printSchematic.setExtent(extent);
    }
}

function updateExcludedGuids(newGuids) {
    if (!newGuids || newGuids.length === 0) {
        return;
    }

    var all = _.union(excludedGuids, newGuids);

    //the uniq operator must be used so the ids can be compared for uniqueness
    excludedGuids = _.uniq(all, false, function (g) {
        return g.attributes[trackFields.TRACK_GUID];
    });
}

function schematicIsReadOnly() {
    var ro = restrictionRequestStore.getReadOnly() || restrictionRequestStore.getPartialReadOnly();

    /*
     * if (restrictionRequestStore.getFormType() === TYPES.A){ if
     * (userStore.getSelectedRole().indexOf(Constants.Roles.FIELD_USER_A) >
     * -1) { //a field user is trying to update a form a, so set the
     * schematic read only // ro = true; } }
     */

    console.log('Schematic readonly = ', ro);
    return ro
}

/**
 * Helper methods *************************************************************************************************
 */
/**
 * MP range methods ===============================================================================================
 */

/**
 * The main entry point to updating the schematic
 * This function determines if we should update the schematic or not, or what we should do next
 */
function determineSchematicAction(action, req) {
    currentRangedText = null;

    if (req == null)
        restriction = restrictionRequestStore.getForm();
    else
        restriction = req;
    defaultTracks = restrictionRequestStore.getDefaultTracks();

    console.log("selection layer", selectionLayer.elements,
        "deselection layer", deselectionLayer.elements,
        "current Restriction Layer", currentRestrictionLayer.elements,
        "excluded guids ", excludedGuids);


    switch (action) {
        case ActionTypes.ADD_GUID:
            console.log('ADD_GUID');

            if (!schematicIsReadOnly()) {


                //only include crossover/turnout tracks, and all connected turnout/crossover,
                //That are in the excludedGuids list (don't add new guids)
                console.log('guids selected:', selectionLayer.elements);
                //reduce the deselection down to only crossover/turnout tracks
                var excludedIds = excludedGuids.map(function (g) {
                    return g.attributes[trackFields.TRACK_GUID]
                });


                //only keep guids to deselect that are excluded, this prevents just adding turnout/crossover guids to any restriction
                var guidsToSelect = selectionLayer.elements.filter(function (g) {
                    return (excludableTracks.indexOf(g.attributes[trackFields.TRACK_NAME].toUpperCase()) > -1) &&
                        (excludedIds.indexOf(g.attributes[trackFields.TRACK_GUID]) > -1)
                });

                if (guidsToSelect.length > 0) {
                    //there are some crossovers to deselect
                    console.log('guidsToSelect:', guidsToSelect);

                    //get every single connected guid
                    for (var i = 0; i < guidsToSelect.length; i++) {
                        var gts = guidsToSelect[i];
                        //examine all the links for gts
                        linkNames.forEach(function (linkName) {
                            var linkId = gts.attributes[linkName];
                            var link = trackLayerGraph[linkId];
                            if (link && link.attributes[trackFields.TRACK_NAME] === gts.attributes[trackFields.TRACK_NAME]) {
                                //this link is also a cross over or a turnout
                                guidsToSelect.push(link);
                            }
                        });
                        //the uniq operator must be used so the ids can be compared for uniqueness
                        //this step is very important, if we don't reduce the list to the unique set,
                        //then we just keep adding the same guids over and over forever!
                        guidsToSelect = _.uniq(guidsToSelect, false, function (g) {
                            return g.attributes[trackFields.TRACK_GUID];
                        });
                    }
                    ;


                    var idsToAdd = guidsToSelect.map(function (g) {
                        return g.attributes[trackFields.TRACK_GUID]
                    });
                    console.log('guidsToSelect:', guidsToSelect);


                    var guidsToKeep = currentRestrictionLayer.elements;
                    _.each(guidsToSelect, function (g) {
                        guidsToKeep.push(g);
                    });
                    console.log('guidsToKeep:', guidsToKeep);

                    //remove any guids from the exclusion list that are in the guidsToAdd list
                    excludedGuids = excludedGuids.filter(function (g) {
                        return idsToAdd.indexOf(g.attributes[trackFields.TRACK_GUID]) < 0
                    });

                    console.log('guidsToKeep', guidsToKeep);
                    console.log('excludedGuids', excludedGuids);
                    console.log('dispatching after ading...');
                    dispatcher.dispatch({
                        type: ActionTypes.SCHEMATIC_UPDATE_COMPLETE,
                        guids: guidsToKeep,
                        excludedGuids: excludedGuids
                    });

                    setSelectedGuids(guidsToKeep);
                    highlightSelectedGuids(true);
                }

            }
            break;

        case ActionTypes.REMOVE_GUID:
            console.log('REMOVE_GUID');
            if (!schematicIsReadOnly()) {

                //var guidsToDeselect = [];

                //only exclude crossover/turnout tracks, and all connected turnout/crossover
                console.log('guids de-selected:', deselectionLayer.elements);
                //reduce the deselection down to only crossover/turnout tracks

                var guidsToDeselect = deselectionLayer.elements.filter(function (g) {
                    return excludableTracks.indexOf(g.attributes[trackFields.TRACK_NAME].toUpperCase()) > -1
                });

                if (guidsToDeselect.length > 0) {
                    //there are some crossovers to deselect
                    console.log('guidsToDeselect:', guidsToDeselect);

                    //get every single connected guid
                    for (var i = 0; i < guidsToDeselect.length; i++) {
                        var gtd = guidsToDeselect[i];
                        //examine all the links for gtd
                        linkNames.forEach(function (linkName) {
                            var linkId = gtd.attributes[linkName];
                            var link = trackLayerGraph[linkId];
                            if (link && link.attributes[trackFields.TRACK_NAME] === gtd.attributes[trackFields.TRACK_NAME]) {
                                //this link is also a cross over or a turnout
                                guidsToDeselect.push(link);
                            }
                        });
                        //the uniq operator must be used so the ids can be compared for uniqueness
                        //this step is very important, if we don't reduce the list to the unique set,
                        //then we just keep adding the same guids over and over forever!
                        guidsToDeselect = _.uniq(guidsToDeselect, false, function (g) {
                            return g.attributes[trackFields.TRACK_GUID];
                        });
                    }
                    ;

                    //add those ids

                    var idsToDeselect = guidsToDeselect.map(function (g) {
                        return g.attributes[trackFields.TRACK_GUID]
                    });
                    console.log('guidsToDeselect:', guidsToDeselect);

                    var guidsToKeep = currentRestrictionLayer.elements.filter(function (g) {
                        return idsToDeselect.indexOf(g.attributes[trackFields.TRACK_GUID]) < 0
                    });
                    console.log('guidsToKeep:', guidsToKeep);

                    var crossoverLeftInSelection = guidsToKeep.filter(function (g) {
                        return g.attributes[trackFields.TRACK_NAME] === 'CROSSOVER'
                    }).length > 0;
                    var turnoutsLeftInSelection = guidsToKeep.filter(function (g) {
                        return g.attributes[trackFields.TRACK_NAME] === 'TURNOUT'
                    }).length > 0;


                    var tracksToRemove = [];
                    if (guidsToDeselect.length > 0) {
                        if (!crossoverLeftInSelection) {
                            tracksToRemove.push('CROSSOVER');
                            //make sure the excluded guids list doesn't have any 'crossovers' in it
                            excludedGuids = excludedGuids.filter(function (g) {
                                return g.attributes[trackFields.TRACK_NAME] != 'CROSSOVER'
                            });
                        }
                        else {
                            updateExcludedGuids(guidsToDeselect);
                        }

                        if (!turnoutsLeftInSelection) {
                            tracksToRemove.push('TURNOUT');
                            //make sure the excluded guids list doesn't have any 'crossovers' in it
                            excludedGuids = excludedGuids.filter(function (g) {
                                return g.attributes[trackFields.TRACK_NAME] != 'TURNOUT'
                            });
                        }
                        else {
                            updateExcludedGuids(guidsToDeselect);
                        }
                    }

                    console.log('tracksToRemove', tracksToRemove);
                    console.log('guidsToKeep', guidsToKeep);
                    console.log('excludedGuids', excludedGuids);
                    console.log('dispatching after removing...');
                    dispatcher.dispatch({
                        type: ActionTypes.SCHEMATIC_UPDATE_COMPLETE,
                        removeTracks: tracksToRemove,
                        guids: guidsToKeep,
                        excludedGuids: excludedGuids
                    });


                    setSelectedGuids(guidsToKeep);
                    highlightSelectedGuids(true);

                }

            }
            else {
                //no op
            }

            break;

        case ActionTypes.FORM_UPDATED:
            console.log('FORM_UPDATED');
            if (!schematicIsReadOnly()) {
                var tracks = schematicUtil.getDistinctTrackNames(restriction.workStartMp, restriction.workStartMpSuffix,
                    restriction.workEndMp, restriction.workEndMpSuffix, subdivision, trackLayer, trackFields, restriction, subdivisionDetails.milePostRangeList, haveGraph, validRenderTypes);
                //tracks = tracks.map(function (tr) {
                //    return {name: tr, checked: true}
                //});

                //The selection may have default tracks, so don't filter those out
                var validTracks = _.union(tracks, defaultTracks).map(function (tr) {
                    return { name: tr, checked: true }
                });

                var filteredTracks = [];

                _.forEach(validTracks, function (tr) {
                    _.forEach(restriction.tracks, function (restTr) {
                        if (restTr.name == tr.name) {
                            filteredTracks.push(restTr);
                        }
                    })
                });

                restriction.tracks = filteredTracks;

                var availableTracks = updateSchematicFromText();
                setTimeout(function () {
                    dispatcher.dispatch({
                        type: ActionTypes.SCHEMATIC_UPDATE_COMPLETE,
                        tracks: availableTracks,
                        guids: currentRestrictionLayer.elements,//the selected guids
                        excludedGuids: excludedGuids//the guids explicitly excluded
                    });
                }, 1);
            }

            break;

        case ActionTypes.OPEN_ITEM:

            console.log('Highlighting new guids for opened item');

            excludedGuids = restriction.excludedGuids || [];

            var availableTracks = updateSchematicFromText();

            dispatcher.dispatch({
                type: ActionTypes.SCHEMATIC_UPDATE_COMPLETE,
                tracks: availableTracks,
                guids: currentRestrictionLayer.elements,//the selected guids
                excludedGuids: excludedGuids//the guids explicitly excluded
            });

            break;

        case ActionTypes.HIGHLIGHT_FROM_GUIDS:

            excludedGuids = restriction.excludedGuids || [];

            if (restriction.trackGuids.length === 0) {

                if (restriction.isPushedFromTss) {
                    console.log('no included guids found in restriction pushed from TSS. Running restriction through highlighting algorithm');

                    var availableTracks = updateSchematicFromText();
                    dispatcher.dispatch({
                        type: ActionTypes.SCHEMATIC_UPDATE_COMPLETE,
                        tracks: availableTracks,
                        guids: currentRestrictionLayer.elements,//the selected guids
                        excludedGuids: excludedGuids//the guids explicitly excluded
                    });
                }
                else {
                    console.log('No guids included in restrictions');
                }
            }
            else {
                console.log('included guids', restriction.trackGuids)
            }

            if (excludedGuids.length === 0) {
                console.log('no excluded guids found');
            }
            else {
                console.log('excluded guids', restriction.excludedGuids)
            }

            //highlight all the guids except the excluded guids
            var selectedIds = restriction.trackGuids.map(function (g) {
                return g[trackFields.TRACK_GUID]
            });

            var selectedGuids = trackLayer.elements.filter(function (g) {
                return selectedIds.indexOf(g.attributes[trackFields.TRACK_GUID]) > -1
            });

            var partialSelectedGuids = selectedGuids.map(function (selectedGuid) {
                //apply the MPs from the restriction.trackGuids to the selectedGuids
                var attr = selectedGuid.attributes,
                    id = attr[trackFields.TRACK_GUID],
                    beginMp = attr[trackFields.TRACK_BMP],
                    endMp = attr[trackFields.TRACK_EMP];

                var restrictionPartialGuid = _.findWhere(restriction.trackGuids, { tmdsUid: id });

                if (restrictionPartialGuid) {

                    if (restrictionPartialGuid.beginMp != beginMp ||
                        restrictionPartialGuid.endMp != endMp) {
                        //the guids have different length, so make the selected guid a partial guid
                        return getPartialGuidContiguous(selectedGuid, restrictionPartialGuid.beginMp, restrictionPartialGuid.endMp);
                    }
                    //it is not partial, so just return it
                    return selectedGuid;
                }
                else {
                    console.log('cannot find guid')
                }


            });

            setSelectedGuids(partialSelectedGuids);
            highlightSelectedGuids(true);

            milePostLayer.clear();

            if (schematicUtil.mpIsLeft(restriction.workStartMp, restriction.workStartMpSuffix, restriction.workEndMp, restriction.workEndMpSuffix, subdivisionDetails.milePostRangeList, haveGraph)) {
                highlightMilePost(restriction.workStartMp, restriction.workStartMpSuffix, Color.purple, true);
                highlightMilePost(restriction.workEndMp, restriction.workEndMpSuffix, Color.purple, false);
            }
            else {
                highlightMilePost(restriction.workEndMp, restriction.workEndMpSuffix, Color.purple, true);
                highlightMilePost(restriction.workStartMp, restriction.workStartMpSuffix, Color.purple, false);
            }

            var tracks = schematicUtil.getDistinctTrackNames(restriction.workStartMp, restriction.workStartMpSuffix,
                restriction.workEndMp, restriction.workEndMpSuffix, subdivision, trackLayer, trackFields, restriction, subdivisionDetails.milePostRangeList, haveGraph, validRenderTypes);

            dispatcher.dispatch({
                type: ActionTypes.TRACK_LIST_UPDATED,
                tracks: tracks
            });

            break;

        default:
            console.log('an unknown action was initiated')
        //no-op
    }
    deselectionLayer.clear();
    selectionLayer.clear();

    currentRangedText = null;

    setTimeout(function () {
        dispatcher.dispatch({
            type: ActionTypes.EXCLUSION_LIST_UPDATED,
            exclusionList: excludedGuids.map(function (g) {
                return g.attributes
            })
        });
    }, 1);

    if (schematicToolbarStore.canAutoCenterAndZoom()) {
        centerAndZoomSchematic(_.union(currentRestrictionLayer.elements, milePostLayer.elements))
    }
}

function highlightRestrictionsForPrint(restrictions) {

    var restrictionGuids = [];

    for (var i = 0; i < restrictions.length; i++) {
        var restriction = restrictions[i];

        excludedGuids = restriction.excludedGuids || [];

        if (restriction.trackGuids.length === 0) {
            console.log('No guids for restriction');
        }

        //highlight all the guids except the excluded guids
        var selectedIds = restriction.trackGuids.map(function (g) {
            return g[trackFields.TRACK_GUID]
        });

        var selectedGuids = trackLayer.elements.filter(function (g) {
            return selectedIds.indexOf(g.attributes[trackFields.TRACK_GUID]) > -1
        });

        var partialSelectedGuids = selectedGuids.map(function (selectedGuid) {
            //apply the MPs from the restriction.trackGuids to the selectedGuids
            var attr = selectedGuid.attributes,
                id = attr[trackFields.TRACK_GUID],
                beginMp = attr[trackFields.TRACK_BMP],
                endMp = attr[trackFields.TRACK_EMP];

            var restrictionPartialGuid = _.findWhere(restriction.trackGuids, { tmdsUid: id });

            if (restrictionPartialGuid) {

                if (restrictionPartialGuid.beginMp != beginMp ||
                    restrictionPartialGuid.endMp != endMp) {
                    //the guids have different length, so make the selected guid a partial guid
                    return getPartialGuidContiguous(selectedGuid, restrictionPartialGuid.beginMp, restrictionPartialGuid.endMp);
                }
                //it is not partial, so just return it
                return selectedGuid;
            }
        });

        restrictionGuids.push.apply(restrictionGuids, partialSelectedGuids)
    }

    // setSelectedGuids(restrictionGuids);
    // highlightGuidsForPrint(true);

    // console.log("Restriction Guids", restrictionGuids);

    return restrictionGuids
}

/**
 * updates the schematic based on the information the user has input into the restriction (FormStore)
 */
function updateSchematicFromText() {

    //we can do a check here to verify that a mp, suffix, or track has changed and only re-render if that is true
    var availableTracks = [];

    console.log('entered text', restriction.workStartMp,
        restriction.workStartMpSuffix,
        restriction.workEndMp,
        restriction.workEndMpSuffix,
        restriction.tracks);

    if (restriction.workStartMp || restriction.workEndMp || restriction.tracks.length > 0 || restriction.workStartMpSuffix || restriction.workEndMpSuffix) {

        var restrictionText = schematicUtil.convertTextToRangedText(restriction.workStartMp,
            restriction.workStartMpSuffix,
            restriction.workEndMp,
            restriction.workEndMpSuffix,
            false,
            restriction,
            subdivisionDetails.milePostRangeList,
            haveGraph);

        ////clear all the layers
        prepSchematicForReHighlight();


        var l = restrictionText.mpPairs.length;
        var restrictionGuids = [];
        //loop through everything and do some highlighting!
        for (var i = 0; i < l; i++) {
            var MP = restrictionText.mpPairs[i];

            ////highlight the restriction
            if (!isNaN(MP.leftMp) && !isNaN(MP.rightMp) && restrictionText.trackNames.length > 0) {
                //highlight some track!!

                var guids = getGuidsContiguous(restrictionText.trackNames, MP.leftMp, MP.rightMp, MP.suffix);

                console.log('selected guids for ', MP.leftMp, MP.suffix, MP.rightMp, MP.suffix, guids);
                var excludedIds = excludedGuids.map(function (g) {
                    return g.attributes[trackFields.TRACK_GUID]
                });
                console.log('excludedGuids for ', MP.leftMp, MP.suffix, MP.rightMp, MP.suffix, excludedGuids);
                guids = guids.filter(function (g) {
                    return excludedIds.indexOf(g.attributes[trackFields.TRACK_GUID]) < 0
                });
                console.log('filtered guids for ', MP.leftMp, MP.suffix, MP.rightMp, MP.suffix, guids);

                _.forEach(guids, function (g) {
                    restrictionGuids.push(g);
                });
            }

            // highlight the start mp
            if (!isNaN(MP.leftMp) && i === 0) {//on first range
                var mpElems = highlightMilePost(MP.leftMp, MP.suffix, Color.purple, true);
            }

            // if (!isNaN(MP.leftMp)) {//on first range
            //     if ( (MP.leftMp == restriction.workEndMp && MP.suffix == restriction.workEndMpSuffix) || (MP.leftMp == restriction.workStartMp && MP.suffix == restriction.workStartMpSuffix))
            //         var mpElems = highlightMilePost(MP.leftMp, MP.suffix, Color.purple, true);
            // }

            // //highlight the end mp
            // if (!isNaN(MP.rightMp) && i === (l - 1)) {//on the last range
            //     var mpElems = highlightMilePost(MP.rightMp, MP.suffix, Color.purple, false)
            // }

            //highlight the end mp
            if (!isNaN(MP.rightMp)) {
                if ((MP.rightMp == restriction.workEndMp && formValidation.suffixesMatch(MP.suffix, restriction.workEndMpSuffix)) || (MP.rightMp == restriction.workStartMp && formValidation.suffixesMatch(MP.suffix, restriction.workStartMpSuffix)))
                    var mpElems = highlightMilePost(MP.rightMp, MP.suffix, Color.purple, false)
            }
        }

        //Combine guids that have been split
        var combinedGuids = [];

        while (restrictionGuids.length > 0) {
            var tempGuid = restrictionGuids.pop();

            if (combinedGuids.length == 0) {
                combinedGuids.push(tempGuid);    //No guids to check against so push the first one
            }
            else {
                var found = false;
                var matchingGuid;
                for (var j = 0; j < combinedGuids.length; j++) {   //Loop through the guids to see if there are any with the same tmds id
                    if (combinedGuids[j].attributes.tmdsUid == tempGuid.attributes.tmdsUid) {
                        matchingGuid = combinedGuids[j];
                        combinedGuids.splice(j, 1);   //Remove the Guid, it is going to be modified then added back in
                        found = true;
                        break;
                    }
                }

                if (found) {
                    //Found a guid with a matching id already in the list, need to combine matchingGuid and tempGuid and add the new joined guid to the list
                    if (matchingGuid.attributes.endMp == tempGuid.attributes.beginMp) {
                        matchingGuid.attributes.endMp = tempGuid.attributes.endMp;
                        matchingGuid.geometry.x2 = tempGuid.geometry.x2;
                        combinedGuids.push(matchingGuid);
                    }
                    else if (matchingGuid.attributes.beginMp == tempGuid.attributes.endMp) {
                        matchingGuid.attributes.beginMp = tempGuid.attributes.beginMp;
                        matchingGuid.geometry.x1 = tempGuid.geometry.x1;
                        combinedGuids.push(matchingGuid);
                    }
                    else {
                        //Guids have matching Id but not matching milepost something is wrong, push both guids to the list and log an error
                        combinedGuids.push(matchingGuid);
                        combinedGuids.push(tempGuid);
                        console.log("Found a Guid with matching id but not matching mps" + matchingGuid);
                    }
                }
                else
                    combinedGuids.push(tempGuid);
            }
        }

        if (combinedGuids.length > 0) {
            console.log('Final guids for restriction ', combinedGuids);
            setSelectedGuids(combinedGuids);

            highlightSelectedGuids(false);
        }


        if (restrictionText.mpPairs.length > 0) {
            var last = restrictionText.mpPairs.length - 1;
            if (!isNaN(restrictionText.mpPairs[0].leftMp) && !isNaN(restrictionText.mpPairs[last].rightMp)) {
                availableTracks = schematicUtil.getDistinctTrackNames(
                    restrictionText.mpPairs[0].leftMp,
                    restrictionText.mpPairs[0].suffix,
                    restrictionText.mpPairs[last].rightMp,
                    restrictionText.mpPairs[last].suffix, subdivision, trackLayer,
                    trackFields, restriction, subdivisionDetails.milePostRangeList, haveGraph, validRenderTypes);
            }
        }
        else {
            if (restrictionText.isParallel) {
                dispatcher.dispatch({
                    type: ActionTypes.SHOW_MODAL_ERROR,
                    message: "No track names are available for selection.  Please enter different mileposts."
                });
            }
        }
    }

    return availableTracks;
}

/**
 * MP range methods ===============================================================================================
 */
/**
 * Contiguous geometry methods +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
 */


/**
 * gets the list of guids, including partials, based on incoming paramters
 * @param sub {String} subdivision name
 * @param trackNames {Array} array of track names
 * @param lmp {Number} beginning milepost
 * @param rmp {Number} end milepost
 * @param sfx {String} milepost suffix
 * @note Below implementation assumes that the milepost is contingous across the whole subdivision
 */
function getGuidsContiguous(trackNames, lmp, rmp, sfx) {

    var hostGuids = getHostGuidsContiguous(trackNames, lmp, rmp, sfx);
    var leftHostGuids = getHostGuidsContiguous(trackNames, lmp, -1, sfx);
    var rightHostGuids = getHostGuidsContiguous(trackNames, -1, rmp, sfx);

    if (leftHostGuids.length === 0) {
        console.warn('No left host found!')
    }
    if (rightHostGuids.length === 0) {
        console.warn('No right host found!')
    }

    //excluding everything that lies outside of the lmp & rmp
    var partialHostGuids = hostGuids.map(function (ogGuid) {
        return getPartialGuidContiguous(ogGuid, lmp, rmp)
    });


    var innerGuids = getInnerGuidsContiguous(trackNames, lmp, rmp, sfx);

    console.log("original hostGuids", hostGuids);
    console.log("partial hostGuids", partialHostGuids);
    console.log("inner guids", innerGuids);

    return _.union(partialHostGuids, innerGuids);
}

/**
 * Gets all of the guids which host either the lmp or the rmp.
 * @param sub
 * @param trackNames
 * @param lmp
 * @param rmp
 * @param sfx
 * @returns {Array.<T>}
 */
function getHostGuidsContiguous(trackNames, lmp, rmp, sfx) {
    var ignoreTrackName = false;
    if (!trackNames) {
        ignoreTrackName = true;
    }


    return trackLayer.elements.filter(function (elem) {
        var attrs = elem.attributes,
            guidSub = attrs[trackFields.TRACK_SUBDIV],
            guidTrackName = attrs[trackFields.TRACK_NAME],
            guidBMP = attrs[trackFields.TRACK_BMP],
            guidEMP = attrs[trackFields.TRACK_EMP],
            guidMPSfx = attrs[trackFields.TRACK_MPSUF];


        return guidSub === subdivision &&
            (ignoreTrackName ? true : trackNames.indexOf(guidTrackName) > -1) &&
            formValidation.suffixesMatch(sfx, guidMPSfx) &&
            ((((guidBMP <= lmp && lmp < guidEMP && guidBMP < guidEMP && lmp < rmp)//guid increases L to R
                ||
                (guidBMP >= lmp && lmp > guidEMP && guidBMP > guidEMP && lmp > rmp))//guid decreases L to R
                ||
                ((guidBMP <= lmp && lmp < guidEMP && guidBMP < guidEMP && lmp > rmp)//guid increases L to R, range decreases L to R
                    ||
                    (guidBMP > lmp && lmp >= guidEMP && guidBMP > guidEMP && lmp < rmp)))//guid decreases L to R, range increases L to R
                ||
                (((guidBMP < rmp && rmp <= guidEMP && guidBMP < guidEMP && lmp < rmp)//guid increases L to R
                    ||
                    (guidBMP > rmp && rmp >= guidEMP && guidBMP > guidEMP && lmp > rmp))//guid decreases L to R
                    ||
                    ((guidBMP < rmp && rmp <= guidEMP && guidBMP < guidEMP && lmp > rmp)//guid increases L to R, range decreases L to R
                        ||
                        (guidBMP >= rmp && rmp > guidEMP && guidBMP > guidEMP && lmp < rmp))));//guid decreases L to R, range increases L to R
    });
}

/**
 * Gets all of the guids which fall entirely between lmp & rmp. Does not return the host guid!
 * @param sub
 * @param trackNames
 * @param lmp
 * @param rmp
 * @param sfx
 * @returns {Array.<T>}
 */
function getInnerGuidsContiguous(trackNames, lmp, rmp, sfx) {
    return trackLayer.elements.filter(function (elem) {
        var attrs = elem.attributes,
            guidSub = attrs[trackFields.TRACK_SUBDIV],
            guidTrackName = attrs[trackFields.TRACK_NAME],
            guidBMP = attrs[trackFields.TRACK_BMP],
            guidEMP = attrs[trackFields.TRACK_EMP],
            guidMPSfx = attrs[trackFields.TRACK_MPSUF];


        return guidSub === subdivision &&
            trackNames.indexOf(guidTrackName) > -1 &&
            formValidation.suffixesMatch(sfx, guidMPSfx) &&
            //guid lies entirely between the lmp & rmp (exclude partial guids)
            (((lmp < guidBMP && guidEMP < rmp && guidBMP < guidEMP && lmp < rmp)//guid increases L to R
                ||
                (lmp > guidBMP && guidEMP > rmp && guidBMP > guidEMP && lmp > rmp))//guid decreases L to R
                ||
                ((lmp > guidBMP && guidEMP > rmp && guidBMP < guidEMP && lmp > rmp)//guid increases L to R, range decreases L to R
                    ||
                    (lmp < guidBMP && guidEMP < rmp && guidBMP > guidEMP && lmp < rmp)));//guid decreases L to R, range increases L to R


    });
}

/**
 * Returns a partial guid between the limits of the selected workStartMp & workEndMp on the restriction, or the lmp/rmp on original Guid, whichever is
 * smaller
 * @param originalGuid
 */
function getPartialGuidContiguous(originalGuid, lmp, rmp) {

    var guidLmp = originalGuid.attributes[trackFields.TRACK_BMP];
    var guidRmp = originalGuid.attributes[trackFields.TRACK_EMP];


    var newGuid = new SvgElement(originalGuid.toJson()),
        newAttr = newGuid.attributes,
        newGeom = newGuid.geometry,
        newBmp = newAttr[trackFields.TRACK_BMP],
        newEmp = newAttr[trackFields.TRACK_EMP];

    //it is possible that this guid is flipped, so both cases below are possible:
    //  <--------------lmp------------>rmp
    //  rmp<--------------lmp------------>

    if (guidLmp > guidRmp) {//decreasing L to R on guid
        if (newBmp > lmp && lmp > newEmp) {//the lmp lands on this guid

            if (lmp > rmp) {//guid is not flipped!
                // assuming this guids layout, the rmp is actually to the right of the lmp
                //modify the guid to stop at lmp on the left side

                var newLeftPoint = interpolateMpOnGuid(originalGuid, lmp);

                newGeom.x1 = newLeftPoint.x;
                newGeom.y1 = newLeftPoint.y;
                newGuid.setGeometry(newGeom);

                newAttr[trackFields.TRACK_BMP] = lmp;
                newGuid.setAttributes(newAttr);
            }
            else {//guid is flipped
                // assuming this guids layout, the lmp is actually to the right of the rmp
                var newRightPoint = interpolateMpOnGuid(originalGuid, lmp);


                newGeom.x2 = newRightPoint.x;
                newGeom.y2 = newRightPoint.y;

                newAttr[trackFields.TRACK_EMP] = rmp;
                newGuid.setAttributes(newAttr);
            }


        }

        if (newEmp < rmp && rmp < newBmp) {//the rmp lands on this guid, so chop what is to the right
            if (lmp > rmp) {//guid is not flipped
                //modify the lmp and the lx,ly point based on interpolation
                var newRightPoint = interpolateMpOnGuid(originalGuid, rmp);


                newGeom.x2 = newRightPoint.x;
                newGeom.y2 = newRightPoint.y;

                newAttr[trackFields.TRACK_EMP] = rmp;
                newGuid.setAttributes(newAttr);
            }
            else {//guid is flipped
                //modify the guid to stop at lmp on the left side
                var newLeftPoint = interpolateMpOnGuid(originalGuid, rmp);

                newGeom.x1 = newLeftPoint.x;
                newGeom.y1 = newLeftPoint.y;
                newGuid.setGeometry(newGeom);

                newAttr[trackFields.TRACK_BMP] = rmp;
                newGuid.setAttributes(newAttr);
            }

        }
    }
    else if (guidLmp < guidRmp) {//increasing L to R
        if (newBmp < lmp && lmp < newEmp) {//the lmp lands on this guid, so chop what is to the left
            if (lmp > rmp) {//the guid is flipped
                //modify the lmp and the lx,ly point based on interpolation
                var newRightPoint = interpolateMpOnGuid(originalGuid, lmp);

                newGeom.x2 = newRightPoint.x;
                newGeom.y2 = newRightPoint.y;

                newAttr[trackFields.TRACK_EMP] = lmp;
                newGuid.setAttributes(newAttr);
            }
            else {//the guid is not flipped
                //modify the guid to stop at lmp on the left side
                var newLeftPoint = interpolateMpOnGuid(originalGuid, lmp);

                newGeom.x1 = newLeftPoint.x;
                newGeom.y1 = newLeftPoint.y;
                newGuid.setGeometry(newGeom);

                newAttr[trackFields.TRACK_BMP] = lmp;
                newGuid.setAttributes(newAttr);
            }

        }

        if (newEmp > rmp && rmp > newBmp) {//the rmp lands on this guid, so chop what is to the right
            if (lmp > rmp) {//the guid is flipped
                //modify the guid to stop at lmp on the left side
                var newLeftPoint = interpolateMpOnGuid(originalGuid, rmp);

                newGeom.x1 = newLeftPoint.x;
                newGeom.y1 = newLeftPoint.y;
                newGuid.setGeometry(newGeom);

                newAttr[trackFields.TRACK_BMP] = rmp;
                newGuid.setAttributes(newAttr);
            }
            else {//the guid is not fipped
                //modify the lmp and the lx,ly point based on interpolation
                var newRightPoint = interpolateMpOnGuid(originalGuid, rmp);

                newGeom.x2 = newRightPoint.x;
                newGeom.y2 = newRightPoint.y;

                newAttr[trackFields.TRACK_EMP] = rmp;
                newGuid.setAttributes(newAttr);
            }

        }
    }
    else {//lmp = rmp, this guid has no length
        console.log('user clicked a guid with no length');
    }

    return newGuid;
}

/**
 * places points of color on the each guid at the correct MP location
 * @param mp
 * @param sfx
 * @param color
 * @returns {*} the geo points of the mp highlihgted
 *
 */
function highlightMilePost(mp, sfx, color, isLeft) {
    var elems = [];
    if (!color) {
        color = Color.purple;
    }

    if (typeof (mp) != 'number') {
        mp = parseFloat(mp)
        if (isNaN(mp)) {
            console.error('MP is not a number!!!!')
        }
    }

    var mpPoints = getMpGeometry(mp, sfx);

    if (mp % 1 === 0)                         //If the milepost is an integer add the .0 to the end of the number
    {
        var bLength = mp.toString().length;
        mp = mp.toPrecision(bLength + 1);
    }

    _.each(mpPoints, function (point) {


        var elem = new SvgElement({
            geometry: point.toJson(),
            symbol: new CompositePointSymbol().addSymbol(
                new SimplePointSymbol({
                    color: color,
                    size: 4,
                    xOffset: 0,
                    yOffset: 0,
                    style: 'triangle-up',
                })).addSymbol(new TextSymbol({
                    text: mp.toString() + (sfx ? sfx : ''),
                    color: color,
                    yOffset: 10,
                    xOffset: isLeft ? -10 : 10,
                    font: {
                        family: "Tahoma",
                        size: 8
                    }
                })).toJson()
        });

        elems.push(elem);
        milePostLayer.addElement(elem);
    });

    return elems;
}

/**
 * gets the list of points where this MP/suffixe exists on all tracks
 * @param mp
 * @param sfx
 * @returns {*}
 */
function getMpGeometry(mp, sfx) {
    //get all the guids that contain the MP
    var elems = getGuidsThatContain(mp, sfx);

    //only show MPs on 'selected' tracks
    elems = elems.filter(function (g) {
        return restrictionRequestStore.getSelectedTracks().indexOf(g.attributes[trackFields.TRACK_NAME]) > -1
    });
    //and only if the guid isn't excluded
    var excludedIds = excludedGuids.map(function (g) {
        return g.attributes[trackFields.TRACK_GUID]
    });
    elems = elems.filter(function (g) {
        return excludedIds.indexOf(g.attributes[trackFields.TRACK_GUID]) < 0
    });

    //foreach one, interpolate to get the point where the MP lies on that guid
    var points = elems.map(function (elem) {
        return interpolateMpOnGuid(elem, mp)
    });
    //return that list
    return points.map(function (p) {
        p.y += 10;
        return p
    });
}

/**
 * returns a list of guids that contain the given MP
 * @param mp
 * @param sfx
 * @returns {Array.<T>}
 */
function getGuidsThatContain(mp, sfx) {
    return trackLayer.elements.filter(function (elem) {
        return (doesGuidContainMp(elem, mp, sfx))
    });
}

/**
 * returns whether this MP lands on this guid
 * @param guid
 * @param mp
 * @param sfx
 * @returns {boolean}
 */
function doesGuidContainMp(elem, mp, sfx) {

    var attrs = elem.attributes,
        guidSub = attrs[trackFields.TRACK_SUBDIV],
        guidBMP = attrs[trackFields.TRACK_BMP],
        guidEMP = attrs[trackFields.TRACK_EMP],
        guidMPSfx = attrs[trackFields.TRACK_MPSUF];

    //If BMP and EMP are zero this is a connecting guid so it should not be selected
    if (guidBMP == 0 && guidEMP == 0)
        return false;

    if (subdivision === guidSub) {


        var mpMatch = false;
        if (guidBMP - guidEMP <= 0) {
            //beg <== end
            if (guidBMP <= mp && mp <= guidEMP) {
                mpMatch = true;
            }
        }
        else {
            //end <== beg
            if (guidEMP <= mp && mp <= guidBMP) {
                mpMatch = true;
            }
        }

        if (mpMatch && formValidation.suffixesMatch(sfx, guidMPSfx)) {
            return true;
        }
    }
    return false;
}

/**
 * gets the point that this mp is on this guid
 * @param guid
 * @param mp
 * @returns {*}
 */
function interpolateMpOnGuid(elem, mp) {

    var attrs = elem.attributes,

        trkLX = attrs[trackFields.TRACK_LX],
        trkLY = attrs[trackFields.TRACK_LY],
        trkRX = attrs[trackFields.TRACK_RX],
        trkRY = attrs[trackFields.TRACK_RY],
        trkBMP = attrs[trackFields.TRACK_BMP],
        trkEMP = attrs[trackFields.TRACK_EMP];

    var px = trkEMP === trkBMP ? trkLX : (((trkRX - trkLX) * (mp - trkBMP)) / (trkEMP - trkBMP)) + trkLX,
        py = trkEMP === trkBMP ? trkLY : (((trkRY - trkLY) * (mp - trkBMP)) / (trkEMP - trkBMP)) + trkLY;

    return new Point({
        x: px,
        y: py
    });
}

function interpolatePointOnGuid(elem, point) {
    var attrs = elem.attributes,
        trkLX = attrs[trackFields.TRACK_LX],
        trkLY = attrs[trackFields.TRACK_LY],
        trkRX = attrs[trackFields.TRACK_RX],
        trkRY = attrs[trackFields.TRACK_RY],
        trkBMP = attrs[trackFields.TRACK_BMP],
        trkEMP = attrs[trackFields.TRACK_EMP];

    point = printSchematic.toGeomPoint(point.x, point.y);


    var deltaMile = Math.abs(trkBMP - trkEMP);
    var guidGeometryLength = lineDistance({ x: trkLX, y: trkLY }, { x: trkRX, y: trkRY });
    var selectionGeometryLength, mpValue;


    if (trkBMP < trkEMP) {
        selectionGeometryLength = lineDistance({ x: trkLX, y: trkLY }, point);

        mpValue = (deltaMile * (selectionGeometryLength / guidGeometryLength)) + trkBMP

    }
    else if (trkBMP > trkEMP) {
        selectionGeometryLength = lineDistance({ x: trkRX, y: trkRY }, point);

        mpValue = (deltaMile * (selectionGeometryLength / guidGeometryLength)) + trkEMP

    }

    return mpValue;
}

function lineDistance(point1, point2) {
    var xs = 0;
    var ys = 0;
    xs = point2.x - point1.x;
    xs = xs * xs;
    ys = point2.y - point1.y;
    ys = ys * ys;
    return Math.sqrt(xs + ys);
}

/**
 * Contiguous geometry methods +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
 */
/**
 * Private Event Handler Methods -----------------------------------------------------------------------------------
 */

/**
 * registers all the click and key up/down handlers for the layers
 * @param that
 */
function registerHandlers() {

    printSchematic.on("load", schematicOnLoad);
    printSchematic.on('click', schematicOnClick);

    trackLayer.on("click", trackLayerOnClick);
    trackLayer.on("mouseover", layerMouseEnter);
    trackLayer.on("mousemove", layerMouseMove);
    trackLayer.on('mouseout', layerMouseOut);

    currentRestrictionLayer.on("click", restrictionLayerOnClick);
    currentRestrictionLayer.on("mouseover", layerMouseEnter);
    currentRestrictionLayer.on("mousemove", layerMouseMove);
    currentRestrictionLayer.on('mouseout', layerMouseOut);

    milePostLayer.on("click", milePostLayerOnClick);

    $(document).keydown(documentKeyDown);
    $(document).keyup(documentKeyUp);

    signalLayer.on('click', signalLayerOnClick);
    RrCrossingLayer.on('click', rrCrossingLayerOnClick);
    switchLayer.on('click', switchLayerOnClick);
    controlPointLayer.on('click', controlPointLayerOnClick);
    alphaTextLayer.on('click', alphaTextLayerOnClick);

    contextMenuFromMpDiv.addEventListener("click", contextOnClick);
    contextMenuToMpDiv.addEventListener("click", contextOnClick);
    contextMenuCancelDiv.addEventListener("click", contextOnClick)

}

function schematicOnClick(e) {
    contextMenu.removeClass();
    contextMenu.addClass('guidHoverHide');
}

function contextOnClick(e) {
    var field;
    console.log(e);
    this.parentElement.className = "guidHoverHide";

    //just need to figure out what the box will say, parse out the field and value....
    switch (this.id) {
        case "fromMpDiv":
            field = "workStartMp";
            break;
        case "toMpDiv":
            field = "workEndMp";
            break;
        case "ctxCancelDiv":
            //no op, just close the box (done above)
            return;
    }

    dispatcher.dispatch({
        type: ActionTypes.SCHEMATIC_CLICKED,
        mp: contextMenuMp.text(),
        sfx: contextMenuSfx.text(),
        field: field
    });
    determineSchematicAction(ActionTypes.FORM_UPDATED);

}

/**
 * Moves a single guid from the track layer to the selection layer and starts the update cycle
 * @param e
 */
function trackLayerOnClick(e) {
    //this highlights the selected guid for viewing before applying to the restriction layer
    var attrs = e.svgElement.attributes;
    if (schematicIsReadOnly()) {

    }
    else if (schematicToolbarStore.isExcluding()) {
        e.svgElement.symbol.setColor(Color.blue);
        selectionLayer.clear();

        var guidSub = attrs[trackFields.TRACK_SUBDIV],
            renderType = attrs['renderType'];

        if (guidSub === subdivision && renderType === "Normal") {
            selectionLayer.addElement(e.svgElement);
            determineSchematicAction(ActionTypes.ADD_GUID);
        }
    }
    else {
        nonExcludingClickHandler(e);
    }
    console.log('Information for GUID ', attrs[trackFields.TRACK_GUID], attrs);
}

/**
 * Moves a single guid to the deselection layer and starts the update cycle
 * @param e
 */
function restrictionLayerOnClick(e) {

    var attrs = e.svgElement.attributes;

    //only remove guids if we're in excluding mode
    if (schematicIsReadOnly()) {

    }
    else if (schematicToolbarStore.isExcluding()) {
        //this highlights the selected guid for viewing before removing from the restriction layer
        e.svgElement.symbol.setColor(Color.red);
        //move the clicked element to the deselectionLayer
        deselectionLayer.addElement(e.svgElement);
        determineSchematicAction(ActionTypes.REMOVE_GUID);
    }
    else {
        nonExcludingClickHandler(e);
    }
    console.log('Information for GUID ', attrs[trackFields.TRACK_GUID], attrs);
}

function nonExcludingClickHandler(e) {
    var bothMps = true;

    var attr = e.svgElement.attributes,
        sfx = attr[trackFields.TRACK_MPSUF];

    var clickMp = interpolatePointOnGuid(e.svgElement, { x: e.pageX, y: e.pageY });
    if (clickMp) {
        clickMp = clickMp.toFixed(1);

        bothMps = restrictionRequestStore.bothMps();

        if (bothMps) {
            //hide the MP window
            hover.removeClass();
            hover.addClass('guidHoverHide');
            //show context menu
            contextMenuMp.text(clickMp);
            contextMenuSfx.text(sfx);
            //make the menu visible
            contextMenu.removeClass();
            contextMenu.css({ top: e.pageY - hover.height() - 10, left: e.pageX });
            contextMenu.addClass('guidHoverShow');
            //register handlers for the spans
        }
        else {//click and let the store figure it out
            dispatcher.dispatch({
                type: ActionTypes.SCHEMATIC_CLICKED,
                mp: clickMp,
                sfx: sfx
            });
            determineSchematicAction(ActionTypes.FORM_UPDATED);
        }
    }
}

/**
 * Pops up an information box on the guid you are hovering over
 * @param e
 */
function layerMouseEnter(e) {
    var attr = e.svgElement.attributes,
        sub = attr[trackFields.TRACK_SUBDIV];

    hover.removeClass();
    hover.css({ top: e.pageY - hover.height() - 10, left: e.pageX });
    hover.addClass('guidHoverShow');

    var attr = e.svgElement.attributes,
        guid = attr[trackFields.TRACK_GUID],
        bmp = attr[trackFields.TRACK_BMP],
        sfx = attr[trackFields.TRACK_MPSUF],
        emp = attr[trackFields.TRACK_EMP],
        name = attr[trackFields.TRACK_NAME];

    if (bmp % 1 === 0)                         //If the milepost is an integer add the .0 to the end of the number
    {
        var bLength = bmp.toString().length;
        bmp = bmp.toPrecision(bLength + 1);
    }

    if (emp % 1 === 0) {
        var eLength = emp.toString().length;
        emp = emp.toPrecision(eLength + 1);
    }

    if (sub != subdivision) {
        guidSub.text('Sub: ' + sub);
    }
    else {
        guidSub.text('');
    }
    guidId.text('Id: ' + guid);
    guidMps.text('Bmp: ' + bmp + (sfx ? sfx : '') + ' Emp: ' + emp + (sfx ? sfx : ''));
    guidTrack.text('Track: ' + name);


    var mp = interpolatePointOnGuid(e.svgElement, { x: e.pageX, y: e.pageY });

    var mpText = 'Cursor MP: ' + (mp ? mp.toFixed(3) : "NA");
    var sfxText = (sfx ? " " + sfx : "");

    currentMp.text(mpText + sfxText);

    e.svgElement.symbol.setColor(Color.purple);
}

function layerMouseMove(e) {
    var attr = e.svgElement.attributes,
        sub = attr[trackFields.TRACK_SUBDIV];

    hover.removeClass();
    hover.css({ top: e.pageY - hover.height() - 10, left: e.pageX });
    hover.addClass('guidHoverShow');

    var attr = e.svgElement.attributes,
        guid = attr[trackFields.TRACK_GUID],
        bmp = attr[trackFields.TRACK_BMP],
        sfx = attr[trackFields.TRACK_MPSUF],
        emp = attr[trackFields.TRACK_EMP],
        name = attr[trackFields.TRACK_NAME];

    if (bmp % 1 === 0)                         //If the milepost is an integer add the .0 to the end of the number
    {
        var bLength = bmp.toString().length;
        bmp = bmp.toPrecision(bLength + 1);
    }

    if (emp % 1 === 0) {
        var eLength = emp.toString().length;
        emp = emp.toPrecision(eLength + 1);
    }

    if (sub != subdivision) {
        guidSub.text('Sub: ' + sub);
    }
    else {
        guidSub.text('');
    }
    guidId.text('Id: ' + guid);
    guidMps.text('Bmp: ' + bmp + (sfx ? sfx : '') + ' Emp: ' + emp + (sfx ? sfx : ''));
    guidTrack.text('Track: ' + name);
    var mp = interpolatePointOnGuid(e.svgElement, { x: e.pageX, y: e.pageY });

    var mpText = 'Cursor MP: ' + (mp ? mp.toFixed(3) : "NA");
    var sfxText = (sfx ? " " + sfx : "");

    currentMp.text(mpText + sfxText);

}

/**
 * Hides the hover box when leaving the guid
 * @param e
 */
function layerMouseOut(e) {
    var attr = e.svgElement.attributes;

    //if (sub === subdivision){
    hover.removeClass();
    hover.addClass('guidHoverHide');

    e.svgElement.symbol.setColor(Color.black);
    //}
}

/**
 * click event for the mile post layer
 * @param e
 */
function milePostLayerOnClick(e) {
    //todo: something
}

/**
 * event handler for docuemnt key down
 * @param e
 */
function documentKeyDown(e) {
    if (schematicToolbarStore.isNavigating()) {//if navigating...either button press changes state
        //if (e.altKey && e.ctrlKey){
        //setDeselect();
        //}
        //else
        if (e.ctrlKey) {
            //setSelect();
            setExclude();
        }
    }
}

/**
 * event handler for document key up
 * @param e
 */
function documentKeyUp(e) {
    switch (e.keyCode) {
        case 27://esc key
            selectionLayer.clear();
            return;
    }
    ;

    if (schematicToolbarStore.isNavigating()) {//navigating, ignore key up
        return;
    }
    else {//selecting or deselecting
        if (e.ctrlKey && !e.altKey) {
            //setSelect();
            setExclude();
        }
        else {
            setNavigate();
        }
    }
}

function signalLayerOnClick(e) {
    console.log('signal clicked ', e.svgElement.attributes);
}

function rrCrossingLayerOnClick(e) {
    console.log('rr crossing clicked ', e.svgElement.attributes);
}

function switchLayerOnClick(e) {
    console.log('switch clicked ', e.svgElement.attributes);
}

function controlPointLayerOnClick(e) {
    console.log('control point clicked ', e.svgElement.attributes);
}

function alphaTextLayerOnClick(e) {
    console.log('alpha text clicked ', e.svgElement.attributes);
}

/**
 * Sets the schematic to navigate mode
 */
function setNavigate() {
    //drawingSelectLayer.clear();
    //drawTool.deactivate();
    dispatcher.dispatch({
        type: ActionTypes.SET_NAVIGATE
    });
}

/**
 * Sets the schematic to mass select mode
 */
function setExclude() {
    dispatcher.dispatch({
        type: ActionTypes.SET_EXCLUDE
    });
}

/**
 * The schematic on load function
 */
function schematicOnLoad(e) {
    console.log('Successfully loaded subdivision into schematic', e);

    trackLayerGraph = {};
    //builds an object where you can deference via the guid to directly get that element.
    //no more searching through lists
    trackLayer.elements.forEach(function (elem) {
        trackLayerGraph[elem.attributes[trackFields.TRACK_GUID]] = elem;

        if (elem.attributes.trackName.toUpperCase() == "MAIN") {
            elem.attributes.trackName = "MAIN TRACK";
        }
    });

    if (subdivision === "FTWORT") {
        var badGuids = trackLayer.elements.filter(function (elem) {
            return elem.attributes[trackFields.TRACK_NAME] === "NOTHING" && elem.attributes['renderType'] === "ZeroMP" && elem.attributes['authorityType'] === "CTC";
        });
        var badAttributes = _.pluck(badGuids, 'attributes');

        var badTerritories = _.pluck(badAttributes, 'territoryAssignment');

        badTerritories = _.uniq(badTerritories);

        var badTrack = trackLayer.elements.filter(function (trackElem) {
            return badTerritories.indexOf(trackElem.attributes['territoryAssignment']) > -1;
        })

        var badSignals = signalLayer.elements.filter(function (signalElem) {
            return badTerritories.indexOf(signalElem.attributes['territoryAssignment']) > -1;
        });

        var badSwitches = switchLayer.elements.filter(function (switchElem) {
            return badTerritories.indexOf(switchElem.attributes['territoryAssignment']) > -1;
        });

        var badAlphaText = alphaTextLayer.elements.filter(function (textElem) {
            return badTerritories.indexOf(textElem.attributes['territoryAssignment']) > -1;
        });

        var badControlPoints = controlPointLayer.elements.filter(function (controlElem) {
            return badTerritories.indexOf(controlElem.attributes['territoryAssignment']) > -1;
        });

        badTrack.forEach(function (elem) {
            trackLayer.removeElement(elem);
        });

        badControlPoints.forEach(function (elem) {
            controlPointLayer.removeElement(elem);
        });

        badAlphaText.forEach(function (elem) {
            alphaTextLayer.removeElement(elem);
        });

        badSignals.forEach(function (elem) {
            signalLayer.removeElement(elem);
        });

        badSwitches.forEach(function (elem) {
            switchLayer.removeElement(elem);
        });

        badGuids.forEach(function (elem) {
            trackLayer.removeElement(elem);
        });
    }

    centerAndZoom();

    dispatcher.dispatch({
        type: ActionTypes.RELOAD_ENTERED_TEXT
    });
}

/**
 * Private Event Handler Methods -----------------------------------------------------------------------------------
 */